import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { UsersPage } from '../features/users/page'

export const usersRoute = createRoute({
  path: 'users',
  getParentRoute: () => rootRoute,
  component: UsersPage,
})
